import { connect } from 'react-redux'
import Lessons from './lessons'
import { fetchSharedCounter } from '../../../../stores/shared-presentations/shared-presentations.actions'

const mapDispatchToProps = dispatch => ({
  onMount: () => dispatch(fetchSharedCounter())
})

export default connect(
  null,
  mapDispatchToProps
)(Lessons)
